// Effect review flags, one place. Each effect is ON by default (Cr3L's choice, 2026-10-18); `?name=0` turns it off,
// `?name=1` still works. The old drawing paths stay for the opt-out.
export function fxFlag(name: 'bossfx' | 'weaponfx' | 'hackfx', search = typeof location !== 'undefined' ? location.search : ''): boolean {
  return new URLSearchParams(search).get(name) !== '0';
}
export const BOSS_FX = fxFlag('bossfx');
export const WEAPON_FX = fxFlag('weaponfx');
export const HACK_FX = fxFlag('hackfx');